import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '@/infrastructure/auth/authStore';

export function PrivateRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? children : <Navigate to="/login" replace state={{ from: location }} />;
}
